import { createFileRoute, Outlet } from '@tanstack/react-router'
import { BrandLogo } from '@/shared/ui/brand'

// Публичная зона хаба: единая страница входа /login (22-unified-login) и экраны
// контура заказчика /customer/*. Сессии здесь не требуется, и сотруднических
// разделов нет by design — ни сайдбара, ни свитчера, ни командной палитры
// (00-architecture § 8.1): заказчик в хабе только входит, выходит и меняет пароль.
export const Route = createFileRoute('/_public')({
  component: PublicLayout,
})

function PublicLayout() {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-8 bg-bg-base px-4 py-12 text-text-primary">
      <div className="flex flex-col items-center gap-4 text-center">
        <BrandLogo className="h-7" />
        <div>
          <h1 className="t-h3">Экосистема STIT</h1>
          <p className="mt-1 text-sm text-text-tertiary">Единый вход в сервисы</p>
        </div>
      </div>
      <div className="flex w-full max-w-sm flex-col gap-4">
        <Outlet />
      </div>
    </main>
  )
}
